import { EntitySelectorsFactory } from '@ngrx/data';
import { createSelector } from '@ngrx/store';
import { CheckItem, createCheckItem } from '@rpe/registro-personas-empresas-lib';
import { selectLaboratorioById } from '../entity-laboratorios/laboratorios.selectors';
import { selectAllTiposDivisorMuestra } from '../entity-tipos-divisor-muestra/tipos-divisor-muestra.selectors';

import { DivisorMuestra } from './divisores-muestra.model';

export const divisorMuestraSelectors =
  new EntitySelectorsFactory().create<DivisorMuestra>('DivisorMuestra');

export const selectAllDivisoresMuestra =
  divisorMuestraSelectors.selectEntities;

// Se retornar los divisores muestra con los tipos en checklist del laboratorio
export const selectDivisoresMuestraCheckList = (laboratorioId: number) => createSelector(
  selectLaboratorioById(laboratorioId),
  selectAllTiposDivisorMuestra,
  (laboratorio, tiposDivisorMuestra) => {
    let lCheckItem : CheckItem[] = [];
    if (laboratorio){
      tiposDivisorMuestra.forEach(tdm => {      
        const existeTDM = laboratorio.divisores_muestra.find(dm => dm.tipo_divisor_muestra_id == tdm.id);   
        const ci = createCheckItem({id: existeTDM ? existeTDM.id : null, tipo_id: tdm.id, nombre: tdm.nombre, selected: existeTDM ? true : false})
        lCheckItem.push(ci)
      })
    } else {
      tiposDivisorMuestra.forEach(tdm => {                   
        const ci = createCheckItem({id: null, tipo_id: tdm.id, nombre: tdm.nombre, selected: false})
        lCheckItem.push(ci)
      })
    }    
    return lCheckItem
  }
);

